<div class="bg-orange-500 text-white h-6 rounded-md text-center align-middle font-semibold p-0" style="height: 21px; min-width: 30px; max-width: 30px">
  {{value()}}
</div>
